export default __webpack_public_path__ + "static/media/bbva.40a53d52.svg";